import { mapGetters, mapMutations, mapActions } from 'vuex';
import { preload } from '@/common/utilities/nojq/_load.js';
import { openOverlayer, closeOverlayer } from '../../utilities/nojq/_overlayer.js';
//import mvtInputGeo from '@/common/components/mvtinputgeo/mvt-inputgeo.vue';
export default {
    name: 'mvtPopOwnup',
    inject: ['$eventBus'],
    props: {
        address: null,
        city: null,
        zipcode: null,
        state: null,
        county: null,
        propertyType: null,
        price: null,
    },
    computed: {
        ...mapGetters('glb', ['glb']),
        ownUpPropertyType() {
            //SingleFamily | Condo | MultiFamily | Townhome | Manufactured | Mobile
            let dict = {
                SINGLE_FAMILY_HOUSE: 'SingleFamily',
                CONDO: 'Condo',
                MULTI_FAMILY: 'MultiFamily',
                MOBILE: 'Townhome',
            };
            return dict[this.propertyType] || 'SingleFamily';
        },
        porpertyAddress() {
            if (this.address.indexOf('#') > -1) {
                return this.address.split('#')[0].replace(/\s+$/, '');
            }
            return this.address;
        },
        propertyUnit() {
            if (this.address.indexOf('#') > -1) {
                return this.address.split('#')[1];
            }
            return '';
        },
        name() {
            if (this.glb.user && this.glb.user.fullName) {
                return this.glb.user.fullName;
            } else if (this.glb.hotleadInfo && this.glb.hotleadInfo.fullName) {
                return this.glb.hotleadInfo.fullName;
            } else {
                return '';
            }
        },
        email() {
            if (this.glb.user && this.glb.user.email) {
                return this.glb.user.email;
            } else if (this.glb.hotleadInfo && this.glb.hotleadInfo.email) {
                return this.glb.hotleadInfo.email;
            } else {
                return '';
            }
        },
        phone() {
            if (this.glb.user && this.glb.user.phone) {
                return this.glb.user.phone;
            } else if (this.glb.hotleadInfo && this.glb.hotleadInfo.phone) {
                return this.glb.hotleadInfo.phone;
            } else {
                return '';
            }
        },
    },
    methods: {
        ...mapActions('glb', []),
        async show(cta) {
            if (cta) {
                this.cta = cta;
            } else {
                this.cta = 'postRE';
            }
            //update html first
            await this.$nextTick();
            const scriptUrl =
                window.location.host.indexOf('movoto.com') > -1
                    ? 'https://cdn.ownup.com/shared-widgets/latest/widgets/portable-questionnaire/questionnaires/movoto/main.js'
                    : 'https://cdn.ownup.com/shared-widgets/latest/widgets/portable-questionnaire/questionnaires/movoto/main.staging.js';
            !this.loadedScripts && (await preload({ files: [scriptUrl], type: 'js' }));
            this.loadedScripts = true;
            this.showOwnUp = true;
            openOverlayer('popownup-active');
        },
        hide() {
            if (this.showOwnUp) {
                this.showOwnUp = false;
                closeOverlayer('popownup-active');
                this.$eventBus.$emit('eventbus-hotlead-step', { trigger: this.$options.name });
            }
        },
    },
    data() {
        return {
            loadedScripts: false,
            showOwnUp: false,
            componentMounted: false,
            cta: 'postRE',
        };
    },
    mounted() {
        this.componentMounted = true;
        //add eventlisenter for close popownup
        document.addEventListener('ownup-complete', this.hide);
    },
};
